import { Schema } from '@bingads-webui-react/overreact';

const schemaToModelMapping = {
  user: 'user',
  customer: 'customer',
  account: 'account',
  sub_geography: 'sub_geography',
  time_zones: 'time_zones',
  countries: 'countries',
  currencies: 'currencies',
  currency_countries_mappings: 'currency_countries_mappings',
  country_currencies_mappings: 'country_currencies_mappings',
  validate_address: 'validate_address',
  sign_up: 'sign_up',
};

export const schema = new Schema(schemaToModelMapping, () => {});
